import styled from 'styled-components'

const InfoWithIcon = styled.div`
  color: ${({ theme }) => theme.brand.jungle};
  a {
    color: inherit;
  }
  svg {
    color: inherit;
    display: inline-block;
    width: 24px;
    height: 24px;
    margin-right: 4px;
    margin-top: -4px;
    font-size: 24px;
    vertical-align: middle;
    line-height: 1;
  }
`

export default InfoWithIcon
